import React from 'react'
import { Alert, ModalBody, ModalHeader } from 'reactstrap'
import AutoTable from 'components/AutoTable'
import { Preference, ValueType } from 'types'
import {
  NO_SITE_PREFERENCES_TEXT,
  SITE_PREFERENCES_MODAL_TITLE,
} from './constants'
import { SitePreferencesModalContainer } from './SitePreferencesModal.styles'

interface SitePreferencesModalProps {
  isOpen: boolean
  preferences: Preference[]
  toggle: () => void
}

export const formatPreferenceValue = ({
  value,
  valueType,
}: Pick<Preference, 'value' | 'valueType'>): string => {
  if (value === null || value === undefined || value === '') {
    return '—'
  }

  switch (valueType) {
    case ValueType.Boolean:
      return value === true || value === 'true' ? 'Yes' : 'No'
    case ValueType.Date:
      return new Date(value).toLocaleDateString('en-us', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    default:
      return String(value)
  }
}

const columns = [
  {
    title: 'Name',
    fieldValue: 'name' as const,
    sortValue: 'name' as const,
  },
  {
    title: 'Value',
    fieldValue: (row: Preference) =>
      formatPreferenceValue({ value: row.value, valueType: row.valueType }),
    sortValue: 'value' as const,
  },
  {
    title: 'Program Code',
    fieldValue: 'programCode' as const,
    sortValue: 'programCode' as const,
  },
  {
    title: 'Value Type',
    fieldValue: 'valueType' as const,
    sortValue: 'valueType' as const,
  },
  {
    title: 'Access Code',
    fieldValue: 'accessCode' as const,
    sortValue: 'accessCode' as const,
  },
  {
    title: 'Assignment Type',
    fieldValue: 'assignmentType' as const,
    sortValue: 'assignmentType' as const,
  },
  {
    title: 'Completed',
    fieldValue: (row: Preference) => (row.isCompleted ? 'Yes' : 'No'),
    sortValue: 'isCompleted' as const,
  },
]

const SitePreferencesModal: React.FC<SitePreferencesModalProps> = ({
  isOpen,
  preferences,
  toggle,
}) => (
  <SitePreferencesModalContainer
    centered
    fade
    isOpen={isOpen}
    size="lg"
    toggle={toggle}
  >
    <ModalHeader toggle={toggle}>{SITE_PREFERENCES_MODAL_TITLE}</ModalHeader>
    <ModalBody>
      {preferences.length > 0 ? (
        <AutoTable
          borderless
          columns={columns}
          headThemeLight
          rows={preferences}
          sort
        />
      ) : (
        <Alert color="info">{NO_SITE_PREFERENCES_TEXT}</Alert>
      )}
    </ModalBody>
  </SitePreferencesModalContainer>
)

export default SitePreferencesModal
